import { Loading } from '@/components/common'

export const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
    <Loading size="lg" text="Loading..." />
  </div>
)

export default PageLoader
